import { documentBundleActions } from 'src/redux/actions/constant';

const {
  SUCCESS_GET_THERAPIST_FILTERS,
  FAILURE_GET_THERAPIST_FILTERS,
  LOADING_GET_THERAPIST_FILTERS,
  RESET_GET_THERAPIST_FILTERS,
} = documentBundleActions;

const initialState = {
  response: null as any,
  loading: false,
};

export const getTherapistFiltersReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOADING_GET_THERAPIST_FILTERS:
      return { ...state, loading: true };
    case SUCCESS_GET_THERAPIST_FILTERS:
      return { ...state, loading: false, response: action.payload };
    case FAILURE_GET_THERAPIST_FILTERS:
      return { ...state, loading: false, response: null };
    case RESET_GET_THERAPIST_FILTERS:
      return initialState;
    default:
      return state;
  }
};
